(function () {
  var BP = 749;

  function setup(section) {
    var track = section.querySelector('[data-icons-track]');
    if (!track) return;

    var mobile = window.matchMedia('(max-width: ' + BP + 'px)').matches;

    if (mobile) {
      if (!track.dataset.marqueeReady) {
        var origItems = Array.from(track.children);
        origItems.forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.classList.remove('scroll-trigger', 'animate--slide-in');
          track.appendChild(clone);
        });
        // remove scroll-trigger from originals to avoid animation conflicts
        Array.from(track.querySelectorAll('.scroll-trigger')).forEach(function (el) {
          el.classList.remove('scroll-trigger', 'animate--slide-in');
        });
        track.dataset.marqueeReady = '1';

        track.addEventListener('touchstart', function () {
          track.classList.add('is-paused');
        }, { passive: true });
        track.addEventListener('touchend', function () {
          track.classList.remove('is-paused');
        }, { passive: true });
      }

      var itemCount = track.children.length / 2;
      var duration = Math.max(10, itemCount * 4);
      track.style.setProperty('--marquee-duration', duration + 's');
      track.classList.add('custom-icons__track--marquee');
    } else {
      track.classList.remove('custom-icons__track--marquee');
    }
  }

  function init() {
    document.querySelectorAll('.section-custom-icons').forEach(setup);
  }

  document.addEventListener('DOMContentLoaded', init);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 150);
  });
})();
